/**
 * api/ai.js
 * REST wrappers for the AI settings-generation endpoint.
 * Namespace: wpbean-pgs/v1/ai
 */

import apiFetch from "@wordpress/api-fetch";

const BASE = "/wpbean-pgs/v1/ai";

/**
 * Check whether an AI provider is configured.
 * Returns { available: bool, reason?: string, connectors_url: string }
 */
export const getAiStatus = () => apiFetch({ path: `${BASE}/status` });

/**
 * Generate gallery settings from a text prompt and/or a reference image.
 *
 * @param {object} data
 * @param {string} [data.prompt]           Free-text design description.
 * @param {string} [data.image_data]       Base64 data URL (data:image/…;base64,…).
 * @param {object} [data.current_settings] Existing settings for context.
 *
 * @returns {{ title: string, settings: object, reasoning: string }}
 */
export const generateSettings = (data) =>
    apiFetch({ path: `${BASE}/generate`, method: "POST", data });
